<template>
  <b-modal v-model="model" centered modal-class="modal-bb-squared" hide-footer>
    <template slot="modal-header" slot-scope="{ close }">
      <h5>Did you find your next job?</h5>
      <p class="fs16 text-gray-700 pt-10">
        We redirected you to our partner site. But most of the jobs are here on
        thehub.io where you can apply faster and easier. Especially if you’re
        signed up.
      </p>
      <button class="close" @click="close()"></button>
    </template>

    <template slot="default">
      <div class="advantages-wrapper">
        <div class="advantages">
          <div class="advantages-item">
            <div class="advantages-item-icon">
              <img src="~/assets/img/icons/finger-snap.svg" alt="finger snap" />
            </div>
            <div class="advantages-item-text">
              <h5>Quick apply</h5>
              <p class="text-gray-700">
                Save your details, apply in just a few clicks
              </p>
            </div>
          </div>

          <div class="advantages-item">
            <div class="advantages-item-icon">
              <img
                style="width: 70px"
                src="~/assets/img/icons/bookmarks.svg"
                alt="finger snap"
              />
            </div>
            <div class="advantages-item-text">
              <h5>Save jobs and apply later</h5>
              <p class="text-gray-700">
                Stay in the flow. Browse jobs, save jobs, browse more, apply
                later
              </p>
            </div>
          </div>

          <div class="advantages-item">
            <div class="advantages-item-icon">
              <img
                style="width: 62px"
                src="~/assets/img/icons/radar.svg"
                alt="finger snap"
              />
            </div>
            <div class="advantages-item-text">
              <h5>Save your searches</h5>
              <p class="text-gray-700">
                Make it easy for next time, save your searches
              </p>
            </div>
          </div>
        </div>
      </div>

      <b-button
        variant="primary"
        class="btn btn-lg w-100 mb-10"
        @click="onSignUp"
        >Sign me up</b-button
      >
      <b-button
        class="btn btn-outline w-100 btn-lg mb-30"
        @click="model = false"
        >No thanks, maybe next time</b-button
      >
      <div class="fs14 text-center">
        Already have an account?
        <a class="text-blue-900" @click.prevent="onSignIn">Log in</a>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
      type: Boolean
    }
  },
  data: () => ({}),
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    onSignUp() {
      this.$store.dispatch('modal/auth', {
        initialRoute: 'signup-landing',
        onCancel() {
          this.$store.dispatch('modal/cancel')
        }
      })
    },
    onSignIn() {
      this.$store.dispatch('modal/auth', {
        initialRoute: 'signin',
        onCancel() {
          this.$store.dispatch('modal/cancel')
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.advantages-wrapper {
  margin: 0 -3.125rem 0 -3.125rem;
  padding: 40px 0;
  border-top: 1px solid #e8e9ea;

  .advantages {
    padding: 0 3.125rem 0 3.125rem;
    width: 80%;
    margin: 0 auto;
    @media (max-width: 480px) {
      text-align: center;
    }
    .advantages-item {
      display: flex;
      align-items: center;
      @media (max-width: 480px) {
        display: block;
      }
      &-icon {
        width: 90px;
        img {
          width: 64px;
        }
        @media (max-width: 480px) {
          margin-bottom: 15px;
        }
      }
      &-text {
        flex: 1;
      }
      & + div {
        margin-top: 40px;
      }
    }
  }
}
</style>
